import React, {useMemo} from 'react';
import {UniversityPart} from '../../../../../networking/repos/UniversityRepository';
import {formQuestionsToTableQuestions, Question} from '../../../../../utils/University';
import QuestionTable from '../QuestionTable';

interface Props {
    formParts: UniversityPart[];
}

const UniversityExperiences: React.FC<Props> = ({ formParts }) => {
    const sections = [
        {
            label: 'Best places in host city',
            questions: [
                'To have a cheap meal', 
                'To meet local students', 
                'To get groceries', 
                'To sightsee and/or to attend cultural activities (theatre, concert, museum)', 
                'To meet other exchange students'
            ],
        },
        {
            label: 'In the host city',
            questions: [
                'To have a cheap meal',
                'Which areas should be avoided?',
                'To what extend did you feel safe and secure?',
                'Does the regarding student have any advice with regards to safety?',
            ]
        },
        {
            label: 'General advice for future students',
            questions: [
                'What would you recommend future students to take with them for Study Abroad?',
                'Do you have any other suggestions for future Study Abroad students?',
                'Suggestions for travelling in the area or surrounding countries for future Study Abroad students?',
            ]
        }
    ];
    
    // Combine all questions of all parts into one big array
    const questions = useMemo(() => {
        const questions: Question[] = [];
        formParts.forEach(part => questions.push(...formQuestionsToTableQuestions(part.active_questions)));

        return questions;
    }, [formParts]);

    // Create parts based on the hardcoded sections (parts)
    const parts = sections.map((section, index) => {
        return {
            id: index,
            label: section.label,
            questions: questions.filter(q => section.questions.includes(q.question))
        }
    });

    return (
        <div className={'university-experiences'}>
            <h1 className={'university-experiences__title'}>Personal experiences</h1>

            <div className={'university-experiences__parts'}>
                { parts.map(part => (
                    <div key={part.id}>
                        <span className={"university-experiences__text university-experiences__text--title"}>{part.label}</span>
                        <div className={"university-experiences__part"}>
                            { part.questions.map(question => (
                                <div className={"university-experiences__table"} key={question.id}>
                                    <QuestionTable question={question} />
                                </div>
                            )) }
                        </div>
                    </div>
                )) }
            </div>
        </div>
    )
}

export default UniversityExperiences;